import { RgModal } from "./RgModal";
import { buildShoppingList } from "./rgModules";

/**
 * ShoppingListModal — liste consolidée des courses au marché.
 * Regroupe les items market des 3 modules dont l'état n'est PAS "stock".
 * Utilisée depuis l'écran Aujourd'hui + le calendrier (clic sur badge marché).
 */
export default function ShoppingListModal({ open, onClose, reservation }) {
  const list = reservation ? buildShoppingList(reservation) : [];
  const name = reservation?.name?.split(" ")[0] || "";
  return (
    <RgModal open={open} onClose={onClose} title={`🧺 Liste de courses · ${name}`} testid="rg-shopping-modal">
      {list.length === 0 ? (
        <p style={{ margin: 0, fontStyle: "italic", color: "#9A9C99" }}>Aucun item à acheter — tout est en stock ou aucun extra actif.</p>
      ) : (
        <>
          <p style={{ margin: "0 0 10px", color: "#6B6E6C", fontSize: 13 }}>{list.length} items à acheter au marché :</p>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {list.map((it, i) => (
              <li key={i} style={{
                display: "flex", alignItems: "center", gap: 10, padding: "8px 12px",
                background: "#fff", border: "1px solid #EAE7E1", borderRadius: 8, marginBottom: 4,
              }}>
                <span style={{ fontSize: 18 }}>{it.icon}</span>
                <span style={{ fontSize: 14 }}>{it.label}</span>
                <span style={{ marginLeft: "auto", fontSize: 10, color: "#9A9C99", textTransform: "uppercase" }}>
                  {it.moduleKey === "petit_dej" ? "petit-déj" : it.moduleKey === "bain_fleurs" ? "bain" : "décor"}
                </span>
              </li>
            ))}
          </ul>
        </>
      )}
    </RgModal>
  );
}
